/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Avatar_Save_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to save avatar" |
*
* @param {Avatar_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const avatar_save_failed = /** @type {((inputs?: Avatar_Save_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Avatar_Save_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l'enregistrement de l'avatar")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al guardar el avatar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao salvar avatar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio avatar fallito")
	return /** @type {LocalizedString} */ ("Failed to save avatar")
});